import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import cr from './cr';
import ce from './ce';

import cView from './cView';

import c30v1a from './c30v1a';
import c51v1a from './c51v1a';

export default class c20v extends cView {

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_c20rListsss: {c20r:[]},
  sdld_c20rDtlsss: {c20r:[]},
  sdld_c20rVsnListsss: {c20r:[]},
  s_c21m_vsn: -1,
  s_c20rc31s: '',
};

/*
static op_loadC20mList = (pd={
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_c20rListsss',
  dd_elmDefss: {
    c20r: { // alias
      elm: 'c20r',
      l_flds: ['_key', '_fst', 'c20rc11s', 'c20rc31s'],
      n_lmt: ic.gn_lmt,
      o_cnd: _dd_datss => {
        let _cnd = `
          COALESCE(c20rcz1i, 10) <> 0
          AND _vsn = _ltt
        `.f(
        );
        return _cnd;
      },
      ld_sortss: [
        { fld: 'c20rc11s', dtn: 'asc', mode: 'nmb'},
      ],
      od_fmts: _d_dats => bf.c(_d_dats, {
        key: _d_dats.d_flds._fst, 
        pfx: '{}'.f(_d_dats.d_flds.c20rcy1t), 
        sch: '{}'.f(_d_dats.d_flds.c20rcy1t), 
      }),
    },
  },
});
*/

static op_loadDtl = (pd={
  elm: null,
}) => 
  (pd.elm == 'c20r') ?
    super.op_loadDtl({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => { // 歴対応のため、key / fst が指定されている場合の扱いを定義要
        let _cnd = pd.cnd ??
          (pd.key) ?
            cf.c(pd.elm, `_key = ${pd.key}`, true, false) // 履歴対応 dd_cldDefss の cf.c も必ず b_ltt = false を設定 -> call_tree において強制適用？
          : (pd.fst) ?
            cf.c(pd.elm, `_fst = ${pd.fst}`, true, true) 
          : cf.c(pd.elm, `_fst = ${global.t?.state.sgcd_cmnStgs.c20r_fst}`, true, true);
        return _cnd;
      }),
      dd_cldDefss: {
        c01r: {
          elm: 'c01r',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('c01r', `c01rb21f = ${_dd_datss.c20r.d_flds._fst}`, true, false)
            return _cnd;
          },
        },
      },
      op_atrAll: () => new Promise( _o_end1 => {

        if (global.t?.state.sgcd_cmnStgs.c20r_fst == 0) { // 管理
          _o_end1();
        }
        else { // 管理以外
          const _tdy = ff.myDT_getDate('today');
          const _date0Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 0);
          const _date1Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 1);
          const _date2Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 2);
          const _date3Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 3);
          const _date4Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 4);
          const _date0Lst = ff.myDT_cnv('ldm', _date0Fst);
          const _date1Lst = ff.myDT_cnv('ldm', _date1Fst);
          const _date2Lst = ff.myDT_cnv('ldm', _date2Fst);
          const _date3Lst = ff.myDT_cnv('ldm', _date3Fst);
          const _date4Lst = ff.myDT_cnv('ldm', _date4Fst);
          const _mth0 = ff.myDT_cnv('mth', _date0Fst);
          const _mth1 = ff.myDT_cnv('mth', _date1Fst);
          const _mth2 = ff.myDT_cnv('mth', _date2Fst);
          const _mth3 = ff.myDT_cnv('mth', _date3Fst);
          const _mth4 = ff.myDT_cnv('mth', _date4Fst);
          const _yearMth0 = ff.myDT_cnv('year-mth', _date0Fst);
          const _yearMth1 = ff.myDT_cnv('year-mth', _date1Fst);
          const _yearMth2 = ff.myDT_cnv('year-mth', _date2Fst);
          const _yearMth3 = ff.myDT_cnv('year-mth', _date3Fst);
          const _yearMth4 = ff.myDT_cnv('year-mth', _date4Fst);

          c51v1a.op_loadSlcList({
            elm: 'c51r',
            op_atrAll: () => new Promise( _o_end2 => {

              const _rsvSttDate = ff.myDT_add('day', _tdy, bf.n(c51v1a.o_getC51ri11s('01040400'))); // 予約受付開始日

              let _rsvOpenDtm = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('01040100')) - 1); // 予約解禁日
              _rsvOpenDtm = `${_rsvOpenDtm} ${c51v1a.o_getC51ri11s('01040200')}:00`

              const _alyThisMth = _mth2; // 今回
              const _alyThisYearMth = _yearMth2; // 今回
              const _alyThisSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
              const _alyThisEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
              const _alyNextMth = _mth3; // 次回
              const _alyNextYearMth = _yearMth3; // 次回
              const _alyNextSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
              const _alyNextEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
              let _alyMsg1 = null;
              let _alyMsg2 = null;
              let _alyMth = null;
              let _alySttDate = null;
              let _alyEndDate = null;
              let _b_alyPrd = false; // apply period
              if ( _tdy < _alyThisSttDate) { // エントリー期間前
                _alyMsg1 = `${_alyThisYearMth} 月分のエントリーは ${_alyThisSttDate} から受付`
                _alyMsg2 = `最大数 ： ${_alyThisMth}月${c51v1a.o_getC51ri11s('02040300')}件`;
                _alyMth = _alyThisYearMth;
                _alySttDate = _alyThisSttDate;
                _alyEndDate = _alyThisEndDate;
              }
              else if ( _tdy >= _alyThisSttDate && _tdy <= _alyThisEndDate) { // エントリー期間
                _alyMsg1 = `${_alyThisYearMth} 月分のエントリーを ${_alyThisEndDate} まで受付中`
                _alyMsg2 = `最大数 ： ${_alyThisMth}月${c51v1a.o_getC51ri11s('02040300')}件`;
                _alyMth = _alyThisYearMth;
                _alySttDate = _alyThisSttDate;
                _alyEndDate = _alyThisEndDate;
                _b_alyPrd = true;
              }
              else { // エントリー期間後
                _alyMsg1 = `${_alyNextYearMth} 月分のエントリーは ${_alyNextSttDate} から受付`
                _alyMsg2 = `最大数 ： ${_alyNextMth}月${c51v1a.o_getC51ri11s('02040300')}件`;
                _alyMth = _alyNextYearMth;
                _alySttDate = _alyNextSttDate;
                _alyEndDate = _alyNextEndDate;
              }
              const _alyMthSttDate = `${_alyMth}-01`;
              const _alyMthEndDate = ff.myDT_cnv('ldm', _alyMthSttDate);

              const _pryThisMth = _mth3; // 今回
              const _pryThisYearMth = _yearMth3; // 今回
              const _pryThisSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('06040100')) - 1); // 予約受付開始日
              const _pryThisEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('06040200')) - 1); // 予約受付終了日
              const _pryNextMth = _mth4; // 次回
              const _pryNextYearMth = _yearMth4; // 次回
              const _pryNextSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('06040100')) - 1); // 予約受付開始日
              const _pryNextEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('06040200')) - 1); // 予約受付終了日
              let _pryMsg1 = null;
              let _pryMsg2 = null;
              let _pryMth = null;
              let _prySttDate = null;
              let _pryEndDate = null;
              let _b_pryPrd = false; // apply period
              if ( _tdy < _pryThisSttDate) { // エントリー期間前
                _pryMsg1 = `${_pryThisYearMth} 月分のエントリーは ${_pryThisSttDate} から受付`
                _pryMsg2 = `最大数 ： ${_pryThisMth}月${c51v1a.o_getC51ri11s('06040300')}件`;
                _pryMth = _pryThisYearMth;
                _prySttDate = _pryThisSttDate;
                _pryEndDate = _pryThisEndDate;
              }
              else if ( _tdy >= _pryThisSttDate && _tdy <= _pryThisEndDate) { // エントリー期間
                _pryMsg1 = `${_pryThisYearMth} 月分のエントリーを ${_pryThisEndDate} まで受付中`
                _pryMsg2 = `最大数 ： ${_pryThisMth}月${c51v1a.o_getC51ri11s('06040300')}件`;
                _pryMth = _pryThisYearMth;
                _prySttDate = _pryThisSttDate;
                _pryEndDate = _pryThisEndDate;
                _b_pryPrd = true;
              }
              else { // エントリー期間後
                _pryMsg1 = `${_pryNextYearMth} 月分のエントリーは ${_pryNextSttDate} から受付`
                _pryMsg2 = `最大数 ： ${_pryNextMth}月${c51v1a.o_getC51ri11s('06040300')}件`;
                _pryMth = _pryNextYearMth;
                _prySttDate = _pryNextSttDate;
                _pryEndDate = _pryNextEndDate;
              }
              const _pryMthSttDate = `${_pryMth}-01`;
              const _pryMthEndDate = ff.myDT_cnv('ldm', _pryMthSttDate);

              const _d_c20rs = global.t?.state.sdld_c20rDtlsss.c20r[0];

              let _subDmn1 = null;
              let _subDmn2 = null;
              _d_c20rs.dld_cldDatsss?.c01r.map( _d_c01rs => {
                if (_d_c01rs.d_flds.c01rt11i == 10) _subDmn2 = _d_c01rs.d_flds.c01rc11s;
                if (_d_c01rs.d_flds.c01rt11i == 20) _subDmn1 = _d_c01rs.d_flds.c01rc11s;
              });

//              let _clt = global.t?.state.sdld_c20rDtlsss.c20r[0].d_flds.c20rc31s;
              const _c20rc31s = _d_c20rs.d_flds.c20rc31s; // クライアント名
              const _c20ri31s = _d_c20rs.d_flds.c20ri31s; // 決済用公開鍵

              cf.myRN_setStt({
                sgcd_stgs: {
                  clt: _c20rc31s, // クライアント名
                  c20ri31s: _c20ri31s, // 決済用公開鍵 
                  subDmn1: _subDmn1,
                  subDmn2: _subDmn2,
                  b_alyPrd: _b_alyPrd,
                  alyMsg1: _alyMsg1,
                  alyMsg2: _alyMsg2,
                  alyMth: _alyMth, // エントリー可能月
                  alyMthSttDate: _alyMthSttDate, // エントリー可能月開始日
                  alyMthEndDate: _alyMthEndDate, // エントリー可能月開始日
                  alySttDate: _alySttDate, // エントリ受付開始日
                  alyEndDate: _alyEndDate, // エントリ受付終了日
                  b_pryPrd: _b_pryPrd,
                  pryMsg1: _pryMsg1,
                  pryMsg2: _pryMsg2,
                  pryMth: _pryMth, // 優先エントリー可能月
                  pryMthSttDate: _pryMthSttDate, // 優先エントリー可能月開始日
                  pryMthEndDate: _pryMthEndDate, // 優先エントリー可能月開始日
                  prySttDate: _prySttDate, // 優先エントリ受付開始日
                  pryEndDate: _pryEndDate, // 優先エントリ受付終了日

                  _00010100: c51v1a.o_getC51ri11s('00010100'), // ホーム画面説明文
                  _00020100: c51v1a.o_getC51ri11s('00020100'), // ホーム画面直接予約文１
                  _00020200: c51v1a.o_getC51ri11s('00020200'), // ホーム画面直接予約文２
                  _00030100: c51v1a.o_getC51ri11s('00030100'), // ホーム画面エントリー文１
                  _00030200: c51v1a.o_getC51ri11s('00030200'), // ホーム画面エントリー文２
                  _00040100: c51v1a.o_getC51ri11s('00040100'), // ホーム画面設定文１
                  _00040200: c51v1a.o_getC51ri11s('00040200'), // ホーム画面設定文２
                  _00050100: c51v1a.o_getC51ri11s('00050100'), // メール署名
                  _00050200: c51v1a.o_getC51ri11s('00050200'), // 通知用メールアドレス
                  _00050310: ff.n(c51v1a.o_getC51ri11s('00050310')), // メール通知
                  _00060100: c51v1a.o_getC51ri11s('00060100'), // 利用規約の表記
                  _00070100: ff.n(c51v1a.o_getC51ri11s('00070100')), // 設備の使用
                  _00080100: c51v1a.o_getC51ri11s('00080100'), // ログイン画面説明文
                  _00080200: ff.n(c51v1a.o_getC51ri11s('00080200')), // 団体のログイン可否
                  _00090100: c51v1a.o_getC51ri11s('00090100'), // ホーム画面優先エントリー文１
                  _00090200: c51v1a.o_getC51ri11s('00090200'), // ホーム画面優先エントリー文２
                  _00100100: c51v1a.o_getC51ri11s('00100100'), // 決済の使用

                  _01010100: c51v1a.o_getC51ri11s('01010100'), // 直接予約一覧画面説明文1
                  _01020100: c51v1a.o_getC51ri11s('01020100'), // 直接予約登録画面説明文1（新規）
                  _01021100: c51v1a.o_getC51ri11s('01021100'), // 直接予約登録画面説明文1（変更）
                  _01022100: c51v1a.o_getC51ri11s('01022100'), // 直接予約登録画面説明文1（閲覧）
                  _01030100: c51v1a.o_getC51ri11s('01030100'), // 利用申請書説明文１
                  _01030101: c51v1a.o_getC51ri11s('01030101'), // 利用申請書説明文１色
                  _01030200: c51v1a.o_getC51ri11s('01030200'), // 利用申請書説明文２
                  _01030201: c51v1a.o_getC51ri11s('01030201'), // 利用申請書説明文２色
                  _01030300: c51v1a.o_getC51ri11s('01030300'), // 利用申請書説明文３
                  _01030301: c51v1a.o_getC51ri11s('01030301'), // 利用申請書説明文３色
                  _01040300: c51v1a.o_getC51ri11s('01040300'), // 予約キャンセル可能日数
                  _01040500: c51v1a.o_getC51ri11s('01040500'), // 支払日基準
                  _01040600: c51v1a.o_getC51ri11s('01040600'), // 支払日日数
                  _01050100: c51v1a.o_getC51ri11s('01050100'), // 直接予約メール文

                  _02010100: c51v1a.o_getC51ri11s('02010100'), // エントリー一覧画面説明文1
                  _02010200: c51v1a.o_getC51ri11s('02010200'), // エントリー一覧画面説明文2
                  _02020100: c51v1a.o_getC51ri11s('02020100'), // エントリー登録画面説明文1（新規）
                  _02021100: c51v1a.o_getC51ri11s('02021100'), // エントリー登録画面説明文1（変更）
                  _02022100: c51v1a.o_getC51ri11s('02022100'), // エントリー登録画面説明文1（閲覧）
                  _02030100: c51v1a.o_getC51ri11s('02030100'), // エントリーメール文
                  _02040300: c51v1a.o_getC51ri11s('02040300'), // エントリー可能最大件数

                  _03020100: c51v1a.o_getC51ri11s('03020100'), // エントリー抽選結果メール文（当選）

                  _04010100: c51v1a.o_getC51ri11s('04010100'), // サイネージ表示文

                  _05010100: c51v1a.o_getC51ri11s('05010100'), // 団体様設定画面文言

                  _06010100: c51v1a.o_getC51ri11s('06010100'), // 優先エントリー一覧画面説明文1
                  _06010200: c51v1a.o_getC51ri11s('06010200'), // 優先エントリー一覧画面説明文2
                  _06020100: c51v1a.o_getC51ri11s('06020100'), // 優先エントリー登録画面説明文1（新規）
                  _06021100: c51v1a.o_getC51ri11s('06021100'), // 優先エントリー登録画面説明文1（変更）
                  _06022100: c51v1a.o_getC51ri11s('06022100'), // 優先エントリー登録画面説明文1（閲覧）
                  _06030100: c51v1a.o_getC51ri11s('06030100'), // 優先エントリーメール文
                  _06040300: c51v1a.o_getC51ri11s('06040300'), // 優先エントリー可能最大件数

                  _07020100: c51v1a.o_getC51ri11s('07020100'), // 優先エントリー抽選結果メール文（当選）

                }
              })
              .then(() => { // 団体ごとのパラメータ
                if (pd.c30r_fst || global.t?.state.sgcd_cmnStgs.c10rb31f > 0 ) {
                  c30v1a.op_loadDtl({
                    elm: 'c30r',
                    fst: (pd.c30r_fst) ? pd.c30r_fst : global.t?.state.sgcd_cmnStgs.c10rb31f,
                    op_atrAll: () => new Promise( _o_end3 => {
                      if (ff.f(global.t?.state.sdld_c30rDtlsss?.c30r)) {
                        const _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
                        const _i15ri11i = _d_c30rs.d_flds.i15ri11i; // 翌々月予約最大件数
                        const _i15ri21i = _d_c30rs.d_flds.i15ri21i; // 翌月予約最大件数
                        const _i15ri31i = _d_c30rs.d_flds.i15ri31i; // 当月予約最大件数
                        const _i15rt32i = _d_c30rs.d_flds.i15rt32i ?? 0; // エントリー申込の可否
                        const _i15rt33i = _d_c30rs.d_flds.i15rt33i ?? 0; // 優先エントリー申込の可否

                        const _i15ri12i = ff.n(_d_c30rs.d_flds.i15ri12i); // 翌々月予約基準日
                        const _i15ri22i = ff.n(_d_c30rs.d_flds.i15ri22i); // 翌月予約基準日
                        const _i15ri32i = ff.n(_d_c30rs.d_flds.i15ri32i); // 当月予約基準日

                        const _rsvEndDate = 
                          (_d_c30rs.d_flds.i15rt41i == 120) ? // 2週間後
//                            ff.myDT_add('day', ff.myDT_getDate('today'), 14)
                            ff.myDT_add('day', _tdy, 14)
                          : (_d_c30rs.d_flds.i15rt41i == 130) ? // 3週間後
//                            ff.myDT_add('day', ff.myDT_getDate('today'), 21)
                            ff.myDT_add('day', _tdy, 21)
                          : (_d_c30rs.d_flds.i15rt41i == 200) ? // 当月末
                            _date0Lst
                          : (_d_c30rs.d_flds.i15rt41i == 210) ? // 一ヶ月後月末
                            _date1Lst
                          : (_d_c30rs.d_flds.i15rt41i == 210) ? // 二ヶ月後月末
                            _date2Lst
                          : (_d_c30rs.d_flds.i15rt41i == 300 && ff.myDT_getNow() < _rsvOpenDtm ) ? // 解禁前
                            _date1Lst
                          : (_d_c30rs.d_flds.i15rt41i == 300 && ff.myDT_getNow() >= _rsvOpenDtm ) ? // 解禁後
                            _date2Lst
                          : null;
                        const _rsvMsg1 = `${_rsvSttDate} から ${_rsvEndDate} の予約を受付中`;
                        const _day = ff.n(_tdy.substr(-2,2));
                        const _maxCnt0 = (_day >= _i15ri32i) ? _i15ri31i : _i15ri21i; // 当月最大件数
                        const _maxCnt1 = (_day >= _i15ri22i) ? _i15ri21i : _i15ri11i; // 翌月最大件数
                        const _maxCnt2 = (_day >= _i15ri12i) ? _i15ri11i : 0; // 翌々月最大件数
//                        const _rsvMsg2 = `最大数 ： ${_mth0}月${_i15ri31i}件、${_mth1}月${_i15ri21i}件、${_mth2}月${_i15ri11i}件`;
                        const _rsvMsg2 = `最大数 ： ${_mth0}月${_maxCnt0}件、${_mth1}月${_maxCnt1}件、${_mth2}月${_maxCnt2}件`;

                        cf.myRN_setStt({
                          sgcd_stgs: _next => {
                            _next.rsvMsg1 = _rsvMsg1;
                            _next.rsvMsg2 = _rsvMsg2;
                            _next.rsvSttDate = _rsvSttDate; // 予約可能利用開始日
                            _next.rsvEndDate = _rsvEndDate; // 予約可能利用終了日
                            _next.d_rsvMaxCnts = {
/*
                              [_yearMth2]: _i15ri11i, // 翌々月予約可能件数
                              [_yearMth1]: _i15ri21i, // 翌月予約可能件数
                              [_yearMth0]: _i15ri31i, // 当月予約可能件数
*/
                              [_yearMth2]: _maxCnt2, // 翌々月予約可能件数
                              [_yearMth1]: _maxCnt1, // 翌月予約可能件数
                              [_yearMth0]: _maxCnt0, // 当月予約可能件数
                            };
                            _next.b_alyAbl = (_i15rt32i == 10) ? true : false; // エントリー可能
                            _next.b_pryAbl = (_i15rt33i == 10) ? true : false; // エントリー可能
                          }
                        })
                        .then(_o_end3);
                      }
                      else {
                        _o_end3();
                      };
                    }),
                  })
                  .then(_o_end2)
                }
                else {
                  _o_end2();
                }
              });
            })
          })
          .then(() => {
            _o_end1();
          });
        };
      }),
    })
  : super.op_loadDtl(pd);

/*
static op_loadVsnList = (pd={
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_c20rVsnListsss',
  dd_elmDefss: {
    c20r: { // alias
      elm: 'c20r',
      l_flds: ['_key', 'c20rcy1t'],
      o_cnd: _dd_datss => {
        let _cnd = `
          _fst = ${global.t?.state.sgc_pageKey}
        `;
        return _cnd;
      },
      ld_sortss: [
        { fld: '_vsn', dtn: 'asc', mode: 'nmb'},
      ],
      od_fmts: _d_dats => bf.c(_d_dats, {
        key: _d_dats.d_flds._key, 
        pfx: '{}'.f(_d_dats.d_flds.c20rcy1t), 
        sch: '{}'.f(_d_dats.d_flds.c20rcy1t), 
      }),
    },
  },
});
*/
static op_loadVsnList = (pd={
}) => 
  (pd.elm == 'c20r') ?
    super.op_loadVsnList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c('c20r', `_fst = ${global.t?.state.sgc_pageFst}`, true, false)
//ff.l('c20v 350: {}'.f(_cnd))
        return _cnd;
      }),
    })
  : super.op_loadVsnList(pd);

$clp_loadLists = () => [ // 親を上書き
  c20v.op_loadSlcList({
    elm: 'c20r',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c20r', '_key > 0', true, true);
//ff.l('340: {}'.f(_cnd));      
      return _cnd;
    },
    ld_sortss: [
      { fld: '_key', dtn: 'asc', mode: 'nmb' },
    ],
  }),
];

$clp_loadDtls = () => [
  c20v.op_loadDtl({
    elm: 'c20r',
    fst: global.t?.state.sgc_pageFst,
  }),
  c20v.op_loadVsnList({
    elm: 'c20r',
  }),
/*
  new Promise( _o_end1 => {
    cf.myRN_saveCmnStgs({
      c20r_key: global.t?.state.sgc_pageKey,
    })
    .then(() => {
      cf.myRN_savePageStgs({
        sgc_pageRole: 'own2',
      })
      .then(() => {
        _o_end1();
      });
    });
  }),
*/
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c20rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      c20r: {
        b_fnd: true,
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            c20rc11s: _dd_datss.c20r.d_flds.c20rc11s ?? '',
            c20rc31s: _dd_datss.c20r.d_flds.c20rc31s ?? '',
            c20ri11s: _dd_datss.c20r.d_flds.c20ri11s ?? '',
            c20ri12s: _dd_datss.c20r.d_flds.c20ri12s ?? '',
            c20ri21s: _dd_datss.c20r.d_flds.c20ri21s ?? '',
            c20ri22s: _dd_datss.c20r.d_flds.c20ri22s ?? '',
            c20ri31s: _dd_datss.c20r.d_flds.c20ri31s ?? '',
            c20ri32s: _dd_datss.c20r.d_flds.c20ri32s ?? '',
          };
//ff.l('c20v 406: {}'.f(_d));
          return _d;
        },
        op_atrIns: async _d_dats => {
          //ff.l('c20v 531: {}'.f(_d_dats))
          const _c20r_fst = _d_dats.d_flds._key;
          const _qrys = [
            `
              INSERT INTO 
                t_c51r 
              (
                _vsn, 
                _ltt, 
                c51rb21f, 
                c51rc11s, 
                c51ri11s, 
                c51rcx1i, 
                c51rcy1t, 
                c51rcy1f, 
                c51rcz1i
              ) 
              SELECT
                1, 
                1, 
                ${_c20r_fst}, 
                c50rc11s, 
                c50ri21s, 
                9999, 
                '2000-01-01 00:00:00', 
                1, 
                10 
              FROM
                t_c50r 
              WHERE
                COALESCE(c50rcz1i, 10) <> 0 
            `,
            `
              UPDATE 
                t_c51r 
              SET 
                _fst = _key 
              WHERE
                c51rb21f = ${_c20r_fst};
            `
          ];
          //ff.l('c20v 531: {}'.f(_qrys))
          await cf.myCB_call_iud({
            ctr: 'qrys',
            elm: 'c51r',
            l_qrys: _qrys,
          });
        },
      },
    },
    op_atrAll: () => new Promise( async _o_end1 => {
      let _d_c20rs = global.t?.state.sdld_c20rDtlsss.c20r[0];
      ff.myCM_srl([
        () => cf.myCB_callQrys({ // スタッフ用サブドメイン
          b_ect: ff.f(_d_c20rs.d_flds.c20ri11s),
          l_tgts: [
            'c01rc11s', //サブドメイン情報
          ],
          d_vals: {
            c01rb21f: global.t?.state.sgc_pageFst,
            c01rc11s: _d_c20rs.d_flds.c20ri11s ?? '',
            c01rt11i: 20,
            c01rt21i: 20,
          },
          op_atrAll: () => new Promise( _o_end2 => {
            cf.myCB_call_dmn(_d_c20rs.d_flds.c20ri11s)
            .then(() => {
              _o_end2(true);
            })
          }),
        }),
        () => cf.myCB_callQrys({ // 団体用サブドメイン
          b_ect: ff.f(_d_c20rs.d_flds.c20ri12s),
          l_tgts: [
            'c01rc11s', //サブドメイン情報
          ],
          d_vals: {
            c01rb21f: global.t?.state.sgc_pageFst,
            c01rc11s: _d_c20rs.d_flds.c20ri12s ?? '',
            c01rt11i: 10,
            c01rt21i: 10,
          },
          op_atrAll: () => new Promise( _o_end2 => {
            cf.myCB_call_dmn(_d_c20rs.d_flds.c20ri12s)
            .then(() => {
              _o_end2(true);
            })
          }),
        }),
        () => cf.myCB_callQrys({ // スタッフ用アカウント
          l_tgts: [
            'c10rc01s',
          ],
          d_vals: {
            c10rb21f: global.t?.state.sgc_pageFst,
            c10rc01s: _d_c20rs.d_flds.c20ri21s ?? '',
            c10rc02s: _d_c20rs.d_flds.c20ri22s ?? '',
          },
        })
      ])
      .then(_o_end1)
    }),
  }),
];

render() {
//ff.l('c20v 418: {}'.f(global.t?.state.sdld_c20rDtlsss))
//ff.l('397: {}'.f(global.t?.state.sgc_pageRole))
//ff.l('c20v 418: {}'.f(global.t?.state.sgcd_cmnStgs.c10r_key))
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        d_lefts: {
          b_vsb: false,
        },
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -10,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_hdrs: {
              d_rhts: {
                l_clds: [
                  ce.c(ce.BtnIconPfx, {
                    key: -10,
                    pfx: '祝日登録',
                    b_row: true,
                    iconName: 'square-o',
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'c70v1a',
                        sgc_pageMode: 'show',
                      }; 
                      //ff.l('c20v1a 580: {}'.f(_d_pageInfs));
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                    d_stlCtas: {
                      marginRight: ic.s(1),
                    },
                  }),
                ],
              },
            },
            o_new: () => {
              global.t?.setState({
                sgc_pnlPhs: 'c20r',
                sgc_pageKey: -1,
                sgc_pageMode: 'new',
              }, () => {
                global.t?.setState({
                  sdld_c20rDtlsss: {
                    c20r:[{
                      d_flds: {
                        c20rc11s: '',
                        c20rc31s: '',
                        c20rcz1i: 10,
                      },
                    }]
                  },
                }, () => {
                  global.t?.setState({
                    sgc_pnlMode: 'dtl',
                  })
                });
              });
            },
            d_bdys: {
              l_clds: [
                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c20rSlcListsss',
                    dd_elmDefss: {
                      c20r: {
                        elm: 'c20r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,

                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },

                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c20rc11s', {
                            b_edt: false,
                            b_key: true,

                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },

                          }), // 企業ID
                          cf.f('c20rc31s', {
                            b_edt: false,

                            d_hdrs: { n_w: ic.s(15)  },
                            d_bdys: { n_w: ic.s(15) },

                          }), // 正式名
                        ]),
                      },
                    },
                  }),
                ]),
              ],
            },
            d_btms: {
              d_news: {
                elm: 'c20r',
                state: 'sdld_c20rDtlsss',
                d_insFlds: {
                  ...cf.e('c20r').d_insFlds, 
                },
              },
            },
          }),

          ce.c(ce.Pnl, {
            key: -20,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
//            b_vsb: true,
            d_hdrs: {
/*
              d_ctrs: {
                l_clds: [
                  ce.c(ce.Pck, {
                    key: -1,
                    phd: '履歴',
                    b_vsb: true,
                    b_edt: true,
                    b_row: true,
                    state: 's_c20r_vsn',
                    b_rvs: true,
                    n_col: 15,
                    ld_iss: global.t?.state.sdld_c20rVsnListsss.c20r,
                    o_onChg: c20v.op_loadDtl,
                  }),
                ],
              },
*/
              d_htys: {
                elm: 'c20r',
                ld_iss: global.t?.state.sdld_c20rVsnListsss?.c20r,
                op_loadDtl: c20v.op_loadDtl,
              },
            },
            d_bdys: {
              l_clds: [
                ce.c(cr.InpTree, {
                  key: -1,
                  state: 'sdld_c20rDtlsss',
                  dd_elmDefss: {
                    c20r: {
                      elm: 'c20r',
                      b_row: false,
                      b_ttl: true,
                      b_subHdr: false,
                      d_cmns: {
                        n_cnt: 1,
                      },
                      dd_fldDefss: cf.myRN_getFldDefs([
                        cf.f('c20rc11s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // ID
                        cf.f('c20rc31s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 正式名
                        cf.f('c20ri11s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 正式名
                        cf.f('c20ri12s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 正式名
                        cf.f('c20ri21s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 正式名
                        cf.f('c20ri22s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 正式名

                        cf.f('c20ri31s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 決済用公開鍵
                        cf.f('c20ri32s', {
                          d_hdrs: {
                            n_w: ic.s(11),
                            n_h: ic.s(2.2)
                          },
                          d_bdys: {
                            n_w: ic.s(15),
                            n_h: ic.s(2.2)
                          },
                        }), // 決済用秘密鍵
                      ]),
                    },
                  },
                }),
              ],
            },
            d_btms: {
            },
          }),

        ],
      }
    })
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
